import * as React from 'react';

import { sections } from 'components/lexemes';

import {
  TabOneContainer,
  TabTwoContainer,
  TabThreeContainer,
  TabFourContainer,
  TabFiveContainer,
  TabSixContainer,
  TabSevenContainer,
  TabEightContainer,
  TabNineContainer,
} from 'containers/tabs';

import PageSection from 'components/page/page-section';
import { TabIdList, TabList, mapColorToTabIdList } from 'components/tab-list';

const mapTabContentToTabIdList: { [key in TabIdList]: React.FC } = {
  [TabIdList.DataCollection]: TabOneContainer,
  [TabIdList.InformationUsage]: TabTwoContainer,
  [TabIdList.InformationDisclosure]: TabThreeContainer,
  [TabIdList.InformationSharing]: TabFourContainer,
  [TabIdList.Rights]: TabFiveContainer,
  [TabIdList.InformationStoring]: TabSixContainer,
  [TabIdList.SecurityAndAge]: TabSevenContainer,
  [TabIdList.ContactUs]: TabEightContainer,
  [TabIdList.UsResidents]: TabNineContainer,
};

export const LandingBlockTwoContainer: React.FC = () => {
  const props = {
    tabs: [
      {
        id: TabIdList.DataCollection,
        label: sections.tabsMenuSection.lxPagePrivacyPolicyTabsMenuSectionListItemOne(),
        content: mapTabContentToTabIdList[TabIdList.DataCollection]({}),
        color: mapColorToTabIdList[TabIdList.DataCollection],
      },
      {
        id: TabIdList.InformationUsage,
        label: sections.tabsMenuSection.lxPagePrivacyPolicyTabsMenuSectionListItemTwo(),
        content: mapTabContentToTabIdList[TabIdList.InformationUsage]({}),
        color: mapColorToTabIdList[TabIdList.InformationUsage],
      },
      {
        id: TabIdList.InformationDisclosure,
        label: sections.tabsMenuSection.lxPagePrivacyPolicyTabsMenuSectionListItemThree(),
        content: mapTabContentToTabIdList[TabIdList.InformationDisclosure]({}),
        color: mapColorToTabIdList[TabIdList.InformationDisclosure],
      },
      {
        id: TabIdList.InformationSharing,
        label: sections.tabsMenuSection.lxPagePrivacyPolicyTabsMenuSectionListItemFour(),
        content: mapTabContentToTabIdList[TabIdList.InformationSharing]({}),
        color: mapColorToTabIdList[TabIdList.InformationSharing],
      },
      {
        id: TabIdList.Rights,
        label: sections.tabsMenuSection.lxPagePrivacyPolicyTabsMenuSectionListItemFive(),
        content: mapTabContentToTabIdList[TabIdList.Rights]({}),
        color: mapColorToTabIdList[TabIdList.Rights],
      },
      {
        id: TabIdList.InformationStoring,
        label: sections.tabsMenuSection.lxPagePrivacyPolicyTabsMenuSectionListItemSix(),
        content: mapTabContentToTabIdList[TabIdList.InformationStoring]({}),
        color: mapColorToTabIdList[TabIdList.InformationStoring],
      },
      {
        id: TabIdList.SecurityAndAge,
        label: sections.tabsMenuSection.lxPagePrivacyPolicyTabsMenuSectionListItemSeven(),
        content: mapTabContentToTabIdList[TabIdList.SecurityAndAge]({}),
        color: mapColorToTabIdList[TabIdList.SecurityAndAge],
      },
      {
        id: TabIdList.ContactUs,
        content: mapTabContentToTabIdList[TabIdList.ContactUs]({}),
        color: mapColorToTabIdList[TabIdList.ContactUs],
      },
      {
        id: TabIdList.UsResidents,
        label: sections.tabsMenuSection.lxPagePrivacyPolicyTabsMenuSectionListItemEight(),
        content: mapTabContentToTabIdList[TabIdList.UsResidents]({}),
        color: mapColorToTabIdList[TabIdList.UsResidents],
      },
    ],
  };

  return (
    <PageSection padding="block" inner={true}>
      <div>
        <TabList tabs={props.tabs} />
      </div>
    </PageSection>
  );
};
